/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForKubernetesClusterOnboarded extends models.ServiceAccountCredentialsBaseForKubernetesCluster {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForKubernetesClusterOnboarded");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForKubernetesClusterOnboarded.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForKubernetesClusterOnboarded>): ServiceAccountCredentialsForKubernetesClusterOnboarded {
        let obj = Object.assign(new ServiceAccountCredentialsForKubernetesClusterOnboarded(), model);
        ServiceAccountCredentialsForKubernetesClusterOnboarded.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForKubernetesClusterOnboarded>): ServiceAccountCredentialsForKubernetesClusterOnboarded {
        if (!model) return null;
        return ServiceAccountCredentialsForKubernetesClusterOnboarded.newInstance(<ServiceAccountCredentialsForKubernetesClusterOnboarded> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForKubernetesClusterOnboarded) {
        if (!obj) return;

        models.ServiceAccountCredentialsForKubernetesClusterOnboarded.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForKubernetesClusterOnboarded): boolean {
        if (models.ServiceAccountCredentialsBaseForKubernetesCluster.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForKubernetesClusterOnboarded.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
